"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FUNC = "[object Function]";
var PureObject = "[object Object]";
function isEmpty(object) {
    // not NAN
    if (typeof object === 'number' && object === object) {
        return true;
    }
    // for array & string
    if ((Array.isArray(object) || object instanceof String) && object.length === 0) {
        return true;
    }
    // for object but null
    if (Object.prototype.toString.call(object) === '[object Object]' && Object.keys(object).length === 0) {
        return true;
    }
    // for null
    if (Object.prototype.toString.call(object) === '[object Null]') {
        return true;
    }
    // for undefined
    if (Object.prototype.toString.call(object) === '[object Undefined]') {
        return true;
    }
    return false;
}
function getObjectType(obj) {
    return Object.prototype.toString.call(obj);
}
function isFunction(obj) {
    return getObjectType(obj) === FUNC;
}
function isPureObject(obj) {
    return getObjectType(obj) === PureObject;
}
function checkIsPrintableKey(e) {
    if (e.ctrlKey || e.metaKey)
        return false;
    var keycode = e.keyCode || e.which;
    if ((keycode > 47 && keycode < 58) || // number keys
        keycode === 32 ||
        keycode === 13 || // space & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
    ) {
        return true;
    }
}
function judgeKey(e, key, keyCode) {
    return e.key === key || e.keyCode === keyCode || e.which === keyCode;
}
function isBackSpace(e) {
    return judgeKey(e, 'Backspace', 8);
}
function getStoreMarks(state) {
    return state.tr.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks()) || [];
}
function warpCommand(adapter, command) {
    return function () {
        return command.apply(null, [adapter].concat(Array.from(arguments)));
    };
}
var detachedDocument = null;
var createDetachedElement = function (tagName) {
    if (!detachedDocument)
        detachedDocument = document.implementation.createHTMLDocument('detach');
    return detachedDocument.createElement(tagName);
};
var Utils = {
    FUNC: FUNC,
    PureObject: PureObject,
    isEmpty: isEmpty,
    getObjectType: getObjectType,
    isFunction: isFunction,
    isPureObject: isPureObject,
    checkIsPrintableKey: checkIsPrintableKey,
    createDetachedElement: createDetachedElement,
    judgeKey: judgeKey,
    isBackSpace: isBackSpace,
    getStoreMarks: getStoreMarks,
    warpCommand: warpCommand
};
exports.Utils = Utils;
//# sourceMappingURL=util.js.map